// extracted by mini-css-extract-plugin
module.exports = {"body":"body__22gsw","link":"link__1bsZx","error":"error__1JFJK"};